import getGiftCardItemsCartSelect from 'modules/cart/redux/selectors/get-gift-cards'
import removeItemCartAction from 'modules/cart/redux/actions/remove-item'

export default function deleteGiftCardGiftAction () {
  return async (dispatch, getState) => {
    logUtil('deleteGiftCardGiftAction').debug('[start]')
    const giftCards = getGiftCardItemsCartSelect(getState())
    if (!giftCards?.length) {
      logUtil('deleteGiftCardGiftAction').debug('[noop] no gift card')
      return
    }

    await Promise.all(
      giftCards.map((giftCardItem) => {
        return dispatch(
          removeItemCartAction({ variantId: giftCardItem.variant_id })
        )
      })
    )
    logUtil('deleteGiftCardGiftAction').debug('[done]')
  }
}
